// Remembers the offer you created in the lobby while you browse other pages,
// so it is still shown as "yours" (and can be cancelled) when you come back.
import {useCallback, useEffect, useState} from "react";

let ownOffer = null;
const listeners = new Set();

export const getOwnOffer = () => ownOffer;

export const setOwnOffer = (offer) => {
    ownOffer = offer;
    listeners.forEach((listener) => listener(offer));
};

export const useOwnOffer = () => {
    const [offer, setOffer] = useState(ownOffer);
    useEffect(() => {
        listeners.add(setOffer);
        setOffer(ownOffer);
        return () => listeners.delete(setOffer);
    }, []);
    const update = useCallback((value) => setOwnOffer(value), []);
    return [offer, update];
};
